<template lang="pug">
.receipt-printer
  v-dialog(v-model="loading")
    v-card(
      color="primary"
      dark)
      v-card-text {{ state }}
      v-progress-linear(
        indeterminate
        color="white"
        class="mb-0")
</template>
<script>
import { mapActions } from "vuex";
import { db } from "@/firebase";
import generateReceiptDoc from "@/utils/generateReceiptDoc";

export default {
  name: "ReceiptPrinter",
  data() {
    return {
      loading: false,
      state: ""
    };
  },
  methods: {
    ...mapActions("print", ["loadJsPDF", "loadFont", "createDoc"]),
    async print(receipts) {
      this.loading = true;
      const items = Array.isArray(receipts) ? receipts : [receipts];

      this.state = "載入列印工具";
      await this.loadJsPDF();
      this.state = "載入字體";
      await this.loadFont();
      this.state = "取得用戶資料";

      const payload = await Promise.all(
        items.map(async item => {
          const payerData = (await db
            .collection("users")
            .doc(item.payer.uid)
            .get()).data();
          return { receipt: item, payer: payerData };
        })
      );

      this.state = "產生PDF...";
      await this.createDoc(generateReceiptDoc(payload));

      this.loading = false;
    }
  }
};
</script>
